import { Injectable, InjectionToken, ComponentFactory, ComponentFactoryResolver } from '@angular/core';
import { ThemeComponentsMap } from '@core/configs/lazy-loader.config';
import { Observable, from } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { ILazyComponent } from '@core/interfaces/lazy-loader/lazy-component.interface';

export const LAZY_MODULES_MAP = new InjectionToken('LAZY_MODULES_MAP', {
  factory: () => ThemeComponentsMap,
});

/**
 * Inspired by The Need for Speed: Lazy Load Non-Routable Modules in Angular
 * {@link} https://netbasal.com/the-need-for-speed-lazy-load-non-routable-modules-in-angular-30c8f1c33093
 */
@Injectable()
export class LazyLoaderService {

  constructor(
    private resolver: ComponentFactoryResolver
  ) { }

  loadComponent<T>(componentImport: Promise<ILazyComponent<T>>): Observable<ComponentFactory<T>> {
    return from(componentImport)
      .pipe(
        take(1),
        map(({ LazyComponent }) => this.resolver.resolveComponentFactory(LazyComponent))
      );
  }

}
